import { ViewModel,View } from "binder"
import { getAsBoolean } from "src/uicomponents/components/utilities";
import { IDefaultValueManipulator } from "../defaultValueManipulator";
import  { BooleanView } from "./boolean-view"
import { IMemberContainer } from "../../../dataModelBuilder-viewModel";

export class BooleanViewModel extends ViewModel implements IDefaultValueManipulator{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new BooleanView();
    }
    public getTypeId(): string {
        return "VM-05668E0E-8710-4A1A-B0D3-29C5B63B58E5"
    }

    public set value(v: boolean) { this._value = getAsBoolean(v); } public get value(): boolean { return this._value;} private _value: boolean;

    setDefaultValue(defaultValue: any): void {
        this.value = defaultValue;
    }
    getDefaultValue():any {
        return this.value;
    }
    verify(owningClass : IMemberContainer): string[] {
        let result = [];
        return result;
    }
}
